import { useEffect } from 'react'

export function useAutoReloadOnVersionChange(interval = 60_000) {
  useEffect(() => {
    const currentVersion = __BUILD_TIME__
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now())
        const data = await res.json()
        console.log('>>>>>> metaVersion: ', data.version)
        // 超过10s，就强制刷新，因为生成 meta.json 跟 __BUILD_TIME__ 中间有时间差
        if (Number(data.version) === Number(currentVersion)) {
          console.log('🔁 New version detected, reloading...')
          window.location.reload() // 强制刷新
        } else {
          console.log('当前为最新版本')
        }
      } catch (err) {
        console.error('Version check failed', err)
      }
    }
    const timer = setInterval(checkVersion, interval)
    return () => clearInterval(timer)
  }, [interval])
}
